<script>
    import {
        getActivityLogsActionType,
        getDisplayUserName,
        getFormatDateAndTime,
        getText,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";

    export let activityLogData = {};

    let isShowInfo = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => (isShowInfo = !isShowInfo);

    const _redirectToAccount = () =>
        goToURL(`/Account/view/${activityLogData.accountId}`);
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowInfo ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Basic Information</p>
        </div>

        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex flex-row gap-x-2">
                    <p class="title">Action Time:</p>
                    <p class="content">
                        {activityLogData?.createdDate
                            ? getFormatDateAndTime(activityLogData.createdDate)
                            : ""}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">User:</p>
                    {getDisplayUserName(activityLogData)}
                    <!-- {#if activityLogData?.accountName}
                        <p class="content cursor-default">
                            {activityLogData.accountName} ({activityLogData.accountEmail})
                        </p>
                    {:else}
                        <p class="content cursor-default">
                            {activityLogData.accountEmail
                                ? activityLogData.accountEmail
                                : "-"}
                        </p>
                    {/if} -->
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Doctor:</p>

                    <p class="content cursor-default">
                        {activityLogData?.accountName
                            ? activityLogData.accountName
                            : "-"}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Controller:</p>
                    <p class="content">
                        {getText(activityLogData?.controller)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Action Type:</p>
                    <p class="content">
                        {getActivityLogsActionType(activityLogData.actionType)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Action:</p>
                    <p class="content">
                        {getText(activityLogData?.entityName)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">ID:</p>
                    <p class="content">
                        {getText(activityLogData?.entityId)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">User Agent:</p>
                    <p class="content">
                        {getText(activityLogData.userAgent)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">IP:</p>
                    <p class="content">
                        {getText(activityLogData.ip)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Source:</p>
                    <p class="content">
                        {getText(activityLogData.source)}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .title {
        width: 150px;
    }

    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
